import { LuxButton } from '@gemini/fe-ds-core';
import { MultiplePatientsButtonsWrapperMobile } from './MultiplePatientsNavigator.styles';
import { useTranslation } from 'react-i18next';
import { CSSProperties, useMemo } from 'react';
import { usePatientStore } from '@store/patientStore';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { generateSortedPatientsList } from '@utils/functions';

interface MultiplePatientsNavigatorProps {
  style?: CSSProperties;
}

export const MultiplePatientsNavigatorMobile = ({
  style,
}: MultiplePatientsNavigatorProps) => {
  const { t } = useTranslation();
  const patients = usePatientStore(state => state.patients);
  const currentPatientIndex = useOnlineBookingStore(
    state => state.currentPatient,
  );
  const setCurrentPatient = useOnlineBookingStore(
    state => state.setCurrentPatient,
  );

  const handleBack = () => {
    if (typeof patientTrueIndex !== 'undefined') {
      setCurrentPatient(onlyTruePatients[patientTrueIndex - 1].tabKey);
    }
  };

  const handleContinue = () => {
    if (typeof patientTrueIndex !== 'undefined') {
      setCurrentPatient(onlyTruePatients[patientTrueIndex + 1].tabKey);
    }
  };

  const onlyTruePatients = useMemo(
    () => generateSortedPatientsList(patients, t),
    [patients],
  );

  const patientTrueIndex = useMemo(
    () => onlyTruePatients.find(p => p.tabKey === currentPatientIndex)?.index,
    [onlyTruePatients, currentPatientIndex],
  );

  const prevPatient = useMemo(() => {
    if (typeof patientTrueIndex !== 'undefined') {
      return onlyTruePatients[patientTrueIndex - 1];
    }
    return undefined;
  }, [patientTrueIndex, onlyTruePatients]);

  const nextPatient = useMemo(() => {
    if (typeof patientTrueIndex !== 'undefined') {
      return onlyTruePatients[patientTrueIndex + 1];
    }
    return undefined;
  }, [patientTrueIndex, onlyTruePatients]);

  const justifyContentValue = useMemo(() => {
    const prevCondition =
      onlyTruePatients.length > 1 && patientTrueIndex && patientTrueIndex > 0;
    const nextCondition =
      onlyTruePatients.length > 1 &&
      patientTrueIndex &&
      patientTrueIndex < onlyTruePatients.length - 1;
    if (prevCondition && nextCondition) {
      return 'space-between';
    } else if (prevCondition) {
      return 'center';
    } else {
      return 'center';
    }
  }, [patientTrueIndex, onlyTruePatients.length]);

  return (
    <MultiplePatientsButtonsWrapperMobile
      justifyContent={justifyContentValue}
      style={{
        ...style,
        display: onlyTruePatients.length > 1 ? 'flex' : ' none',
      }}
    >
      {typeof patientTrueIndex !== 'undefined' &&
        prevPatient?.content &&
        onlyTruePatients.length > 1 &&
        patientTrueIndex > 0 && (
          <LuxButton
            variant="ghost"
            iconStart="ChevronLeftIcon"
            onClick={handleBack}
          >
            {t('generalCta.manage') + ' ' + prevPatient?.content}
          </LuxButton>
        )}
      {typeof patientTrueIndex !== 'undefined' &&
        nextPatient?.content &&
        onlyTruePatients.length > 1 &&
        patientTrueIndex < onlyTruePatients.length - 1 && (
          <LuxButton
            variant="ghost"
            iconEnd="ChevronRightIcon"
            onClick={handleContinue}
          >
            {t('generalCta.manage') + ' ' + nextPatient?.content}
          </LuxButton>
        )}
    </MultiplePatientsButtonsWrapperMobile>
  );
};
